/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * An enumeration.
 */
export enum StorageTierStatus {
    REQUESTED = 'requested',
    APPLYING = 'applying',
    REHYDRATING = 'rehydrating',
    APPLIED = 'applied',
    FAILED = 'failed',
    CANCELLED = 'cancelled',
}
